import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getPublications, deletePublication } from "../../api/publicationsApi";
import { translateAuthError } from "../../api/authApi";

// Section C (admin-only): lists every publication (magazine) with
// manage-cards/edit/delete actions and a link to create a new one.
function AdminPublicationsPage() {
  const [publications, setPublications] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    getPublications()
      .then(setPublications)
      .catch((err) => setError(translateAuthError(err.message)))
      .finally(() => setLoading(false));
  }, []);

  async function handleDelete(slug) {
    if (!window.confirm("این نشریه و تمام کارت‌های آن حذف شود؟")) return;
    try {
      await deletePublication(token, slug);
      setPublications((prev) => prev.filter((p) => p.slug !== slug));
    } catch (err) {
      setError(translateAuthError(err.message));
    }
  }

  return (
    <div className="admin-page">
      <Link to="/admin" className="back-link">
        ← بازگشت به پنل مدیریت
      </Link>

      <div className="admin-page-header">
        <h1>مدیریت نشریه‌ها</h1>
        <Link to="/admin/publications/new" className="nav-cta">
          نشریهٔ جدید
        </Link>
      </div>

      {error && <p className="error">{error}</p>}

      {!loading && publications.length === 0 && !error && (
        <p className="admin-empty">هنوز نشریه‌ای ثبت نشده است.</p>
      )}

      <ul className="admin-article-list">
        {publications.map((p) => (
          <li key={p.slug} className="admin-article-row">
            <span>{p.title}</span>
            <div className="admin-actions">
              <button type="button" onClick={() => navigate(`/admin/publications/${p.slug}/topics`)}>
                مدیریت کارت‌ها
              </button>
              <button type="button" onClick={() => navigate(`/admin/publications/${p.slug}/edit`)}>
                ویرایش
              </button>
              <button type="button" onClick={() => handleDelete(p.slug)}>
                حذف
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default AdminPublicationsPage;
